import { GuiUtils } from "src/modules/utils/misc/gui-utils";
import { FrontendField } from "../netgen/FrontendField";

export class FrontendFieldAddon {

    static makeOpenFileButton(selectFolder = false): FrontendFieldAddon {
        return new FrontendFieldAddon("open", "", "fas fa-upload", true, async (_, field) => {
            field.setValue(await GuiUtils.openDialog(null, selectFolder), true);
        });
    }

    id = "";
    text = "";
    icon = "";
    isButton = false;
    onClick: (item: FrontendFieldAddon, field: FrontendField, event: MouseEvent) => any;
    onIsEnabled: (item: FrontendFieldAddon, field: FrontendField) => boolean;

    constructor(id: string, text: string, icon: string, isButton = false, onClick?: (item: FrontendFieldAddon, field: FrontendField, event: MouseEvent) => any, onIsEnabled?: (item: FrontendFieldAddon, field: FrontendField) => boolean) {
        this.id = id;
        this.text = text;
        this.icon = icon;
        this.isButton = isButton;
        this.onClick = onClick;  
        this.onIsEnabled = onIsEnabled;
    }

    isEnabled(field: FrontendField): boolean {  
        return this.onIsEnabled != null ? this.onIsEnabled(this, field) : true;
    }
}
